import * as Yup from "yup";
import { validationErrors } from "./validationRules.js";
import validationUtils from "./validationUtils.js";

const resetPasswordSchema = Yup.object().shape({
  password: validationUtils?.validatePassword(),
  confirm: Yup.string()
    .required(validationErrors?.getRequiredField("confirm password"))
    .test(
      "passwords-match",
      validationErrors?.password?.notMatch,
      function (value) {
        // Only check match if both fields have values
        return !value || this?.parent?.password === value;
      }
    ),
});

export default resetPasswordSchema;